package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun PrestidigitationMetadata() {
    SpellMetadata(
        spellIndex = "prestidigitation",
        castingTime = "1 action",
        range = "10 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC),
        material = null,
        duration = "1 hour",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = false
    )
}
